<script setup lang="ts">
const emit = defineEmits(["open-help-modal"]);

const openHelpModal = (event: any) => emit("open-help-modal", event);
</script>

<template>
  <div class="helpModal-btn" @click="openHelpModal">
    <img
      src="~/assets/images/compare/icon_question-mark-circle.svg"
      width="20"
      height="20"
      alt=""
    />
  </div>
</template>

<style lang="scss" scoped>
.helpModal-btn {
  width: 5.33vw;
  height: 5.33vw;
  padding: 0 0 0 18%;
}
@include media(pc) {
  .helpModal-btn {
    width: 20px;
    height: 20px;
    margin-left: 8px;
    padding: 0;
    cursor: pointer;
  }
  .helpModal-btn img {
    width: 20px;
    height: 20px;
  }
  .helpModal-btn:hover {
    opacity: 0.48;
  }
}
</style>
